import { render, staticRenderFns } from "./InvoiceType.vue?vue&type=template&id=54dce38f&scoped=true"
import script from "./InvoiceType.vue?vue&type=script&lang=js"
export * from "./InvoiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dce38f",
  null
  
)

export default component.exports